<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      
      <div
        class="content  content-attestate"
        v-loading.fullscreen.lock="loading"
      >
         <div class="go-back" @click="goBack">返回</div>
         <div class="btn_box">
            
           <div class="main-title">企业联系人管理</div>
            <div class="search_box"><el-button size="medium" class="search" @click="changeContact('add','')"  type="primary">添加联系人</el-button></div>
         </div>
        <div class="invitate-wrap">
          
          <!-- 列表 -->
          <div class="invitation-table">
            <div class="zs_list">
              <template v-if="tableData.length>0">
                <div class="zs_item"  v-for="(item,index) in tableData" :key="index">
                  <div  class="first_box">
                    <div>
                      <span>{{ item.id }}</span>
                      <span>{{ item.fullname }}</span>
                    </div>
                     <div class="status">{{item.contacts_type}}</div>
                  </div>
                  <div  class="s_box">
                     <div class="s_f_box">
                        <div class="info_box">
                          <div class="info_name">
                            <span style="margin-right: 10px;">电话：{{ item.mobile }}</span>
                          </div>
                          <div>邮箱：{{ item.email }}</div>
                        </div>
                     </div>
                     <div>
                         <span class="btn" @click="changeContact('edit',item.contacts_long_id)">编辑</span>
                         <span class="btn" @click="del(item)">删除</span>
                     </div>

                  </div>
              </div>
              </template>
           
              <nodata v-else></nodata>
            </div>

          </div>
        </div>
      
        <el-pagination
          v-if="total > 0"
          @current-change="handleCurrentChange"
          :current-page.sync="page_no"
          :page-size="page_size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      
      </div>
    </div>
  </div>
</template>

<script>
import {
  contactsLists,
    delContacts
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import nodata from "../components/nodata.vue";//暂无数据
export default {
  components: { top, navMenu ,nodata},
  name: "attestation",
  data() {
    return {
      loading: false,
      active: 0,
      total:0,
      page_no: 1,
      page_size: 10,
      tableData: [],
      mark:''
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "conference";
    });
    this.active = index;
    this.id = this.$route.query.id;
    this.mark=this.$route.query.mark;

    this.getList(this.page_no);
  },
  methods: {
    // 返回
    goBack() {
        this.$router.back();
      },
      //编辑
    changeContact(type,contacts_long_id){
        this.$router.push({
            path:'/contactPerson',
            query:{
              type,
              contacts_long_id,
              mark:this.mark
            }
        })
    },
      // 列表
    getList(page_no) {
      let that=this;
      let data = that.$qs.stringify({
        page_no:page_no,
        page_size: that.page_size,
      });
      contactsLists(data).then((res) => {
          if (res.data.code == 1) {
            console.log(res.data.data.lists,"res.data.data.lists")
            
            that.tableData = res.data.data.lists;
            that.total=Number(res.data.data.count);
         
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页相关
    handleCurrentChange(val) {
      this.page_no = val;
      this.getList(this.page_no);
    },
      // 删除
    del(row) {

      this.$alert(`确定要删除吗?`, "", {
        confirmButtonText: "确定",
        callback: (action) => {
          console.log(action, "===action");
          if (action == "confirm") {
              delContacts({ contacts_long_id: row.contacts_long_id }).then((res) => {
                if (res.data.code == 1) {
                    this.getList(this.page_no);
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
    .btn:nth-child(1){
         margin-right: 20px;
        cursor:pointer;
        color: #1677ff;
    }
    .btn:nth-child(2){
        cursor:pointer;
        color: #ff4d4f;
    }
/deep/ .el-button{
  position: initial;
}
.btn_box{
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 30px;
}

.my-table tbody tr td .check-btn.check-del {
  color: #ff4d4f;
  margin-left: 0 !important;
}
</style>
<style lang="scss">

.search{
  bottom:initial !important;
  left: 104px !important;
}
.zs_list{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 35px;
}
.zs_item{
    width: -webkit-calc((100% - 25px * 3)/ 3);
    width: calc((100% - 25px * 3) / 3);
    margin: 0 25px 25px 0;
    background: #fff;
    border-radius: 6px;
   
}
.s_box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  .s_f_box{
    display: flex;
    align-items: center;
  }
  .del_icon{
    width: 30px;
    height: 30px;
    background: #fa6400;
    border-radius: 50%;
  }
  .avatar{
  width: 60px;
  height: 60px;
  background: #959ec4;
  margin-right: 10px;
}
.info_box{
  font-size: 14px;
  .info_name{
    margin-bottom: 10px;
  }
}
}

.first_box{
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  .status{
      padding: 10px 20px;
      box-sizing: border-box;
      font-size: 12px;
      background: #f7b500;
      border-radius: 6px;
  }
  div{
    display: flex;
    align-items: center;
    img{
    width: 30px;
    height: 30px;
    background: #000;
    border-radius: 50%;
    }
    span{
      display: inline-block;
      margin-left: 10px;
    }
  }
  
}

  .code_txt{
     display: flex;
     flex-direction: column;
     justify-items: center;
     align-items: center;
  }
  .code_txt div:nth-child(1){
    margin-bottom: 10px;
  }
  .code_box{
    width: 100%;
    background: #fff;
    margin: 30px 0;
    display: flex;
    align-items: center;
  }

  // 下载小程序码
  .down-code {
    width: 212px;
    // min-height: 212px;
    font-size: 16px;
    color: #48484a;
    line-height: 22px;
    align-items: center;
    padding: 25px;
    box-sizing: border-box;
    margin-right: 20px;

    border-radius: 9px;
    img {
      max-width: 100%;
      height: auto !important;
    }
  }
  .invitation-infor {
    align-items: center;
    width: 254px;
    height: 82px;
    padding: 23px;
    font-size: 14px;
    color: #959ec4;
    margin-left: 30px;
    margin-top: 50px;
    border-radius: 18px;
    box-sizing: border-box;
    border: 1px solid #959ec4;
    background: #fafcfe;
    .icon {
      width: 9px;
      height: 9px;
      margin-right: 16px;
      background: #4f6ef7;
      border: 19px solid #e8edfd;
      border-radius: 50%;
    }
    .icon1 {
      background: #fa6400;
      border-color: #f9ece4;
    }
    .icon2 {
      background: #5eb581;
      border-color: #e9f4f1;
    }
    .number {
      flex: 1;
      font-size: 30px;
      font-weight: 500;
      color: #373c52;
      text-align: right;
    }
  }
  // 已邀请观众列表
  .invitation-table {

    flex: 1;
    .table-title {
      font-size: 20px;
      font-weight: 500;
      color: #2c2c2e;
      line-height: 28px;
      span {
        font-size: 16px;
        color: #636366;
      }
    }
  }

.my-table {
  color: #888;
  font-size: 16px;
  margin-top: 10px;
}
.my-table tbody td,
.my-table tbody th {
  height: 70px;
  padding: 5px 0;
  box-sizing: border-box;
}
.my-table tbody th,
.my-table tbody tr {
  background: #f2f6fb;
}
.my-table tbody tr.is-new {
  color: #0e0e0e;
}
.my-table tbody tr td .check-btn {
  color: #1677ff;
  cursor: pointer;
}
.my-table tbody tr td .check-btn:hover {
  text-decoration: underline;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: 0 none;
}
/* 表格最外层边框-底部边框 */
.el-table--border::after,
.el-table--group::after {
  width: 0;
}
.my-table::before {
  width: 0;
}
.my-table tbody tr td:first-child {
  border-radius: 10px 0 0 10px;
}
.my-table tbody tr td:last-child {
  border-radius: 0 10px 10px 0;
}
.content-attestate .el-pagination {
  margin-top: 300px;
  text-align: right;
  .el-pager li,
  .el-pagination__total {
    font-size: 14px;
  }
  .el-pagination__jump {
    font-size: 14px;
  }
}
.real {
  width: 85px;
  height: 28px;
  font-weight: 500;
  font-size: 14px;
  color: #0091ff;
  line-height: 28px;
  text-align: center;
  background: rgba(0, 145, 255, 0.15);
  border-radius: 5px;
  display: inline-block;
}
.un-real {
  color: #f7b500;
  background: rgba(247, 181, 0, 0.15);
}
@media only screen and (max-width: 1280px) {
  .zs_item{
    width: 100% !important;
    margin-right: 0 !important;
  }
}
@media only screen and (max-width: 767px) {
.zs_list{
  width: 90%;
margin: auto;
}
.btn_box{
  flex-wrap: wrap;
}
  .content{
    padding: 30px 0 130px 0;
  }

  .zs_item{
    width: 100% !important; 
    margin: 0 0 25px 0 !important; 
  }
  .content .el-button {
    font-size: 15px !important;
  }
 .invitation-table .table-title {
    font-size: 16px !important;
    span{
      font-size: 12px !important;
    }
  }
  .s_box .info_box {
    font-size: 12px !important;
}
.s_box .avatar {
    width: 50px!important;
    height: 50px!important;
    margin-right: 4px!important;
}
.first_box .status {
  padding: 6px 16px!important;
}

}
</style>